import { useLocation } from 'react-router-dom';

interface StructuredDataProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
}

function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫屋',
    url: 'http://lhrkj3.com/',
    description: '韩漫屋 — 韩漫在线阅读平台，提供免费韩国漫画大全，无删减下拉式韩漫，保证内容的原始风貌。',
    logo: 'http://lhrkj3.com/logo.png',
    sameAs: ['http://lhrkj3.com/'],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@lhrkj3.com',
      availableLanguage: ['Chinese'],
    },
  };
}

function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫屋',
    url: 'http://lhrkj3.com/',
    description: '韩漫屋 — 韩漫在线阅读平台，提供免费韩国漫画大全，无删减下拉式韩漫。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://lhrkj3.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };
}

function getWebPageSchema(pathname: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫屋 - 韩漫在线阅读',
    url: `http://lhrkj3.com/${pathname}`,
    description: '在韩漫屋体验舒适的韩漫在线阅读，免费韩国漫画大全任您浏览。',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫屋',
      url: 'http://lhrkj3.com/',
    },
  };
}

function getBreadcrumbSchema(pathname: string) {
  const segments = pathname.split('/').filter(Boolean);
  const breadcrumbMap: Record<string, string> = {
    category: '分类',
    romance: '恋爱浪漫',
    action: '动作冒险',
    fantasy: '奇幻魔法',
    thriller: '悬疑惊悚',
    office: '职场生活',
    scifi: '科幻未来',
    comic: '漫画详情',
    about: '关于我们',
  };

  const items = [
    {
      '@type': 'ListItem' as const,
      position: 1,
      name: '首页',
      item: 'http://lhrkj3.com/',
    },
  ];

  segments.forEach((seg, i) => {
    const name = breadcrumbMap[seg] || seg;
    items.push({
      '@type': 'ListItem' as const,
      position: i + 2,
      name,
      item: `http://lhrkj3.com/${segments.slice(0, i + 1).join('/')}`,
    });
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
}

export default function StructuredData({ type, data }: StructuredDataProps) {
  const location = useLocation();

  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = data ? { ...getOrganizationSchema(), ...data } : getOrganizationSchema();
      break;
    case 'WebSite':
      schema = data ? { ...getWebSiteSchema(), ...data } : getWebSiteSchema();
      break;
    case 'WebPage':
      schema = data ? { ...getWebPageSchema(location.pathname), ...data } : getWebPageSchema(location.pathname);
      break;
    case 'BreadcrumbList':
      schema = data ? { ...getBreadcrumbSchema(location.pathname), ...data } : getBreadcrumbSchema(location.pathname);
      break;
    case 'FAQPage':
      schema = { '@context': 'https://schema.org', '@type': 'FAQPage', ...data };
      break;
    case 'Article':
      schema = { '@context': 'https://schema.org', '@type': 'Article', inLanguage: 'zh-CN', ...data };
      break;
    default:
      schema = { '@context': 'https://schema.org', ...data };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}